import React from 'react'
import { Form, Radio } from 'semantic-ui-react';


const Settings = ({ profile, onSaveProfile }) => {

    const setLengthUnit = (e, {value}) => {
        let data = {
            units_length: value
        }
        console.log(data);
        onSaveProfile(data);
    }

    const setPowerUnit = (e, {value}) => {
        let data = {
            units_power: value
        }
        console.log(data);
        onSaveProfile(data);
    }

    return (
        <div>
            <Form>
                <div className="ui segment">
                    <label>Units</label>
                    <Form.Group inline>
                        <Form.Field>
                            <Radio
                                label='meters'
                                name='radioGroupLength'
                                value={0}
                                checked={profile.units_length === 0}
                                onChange={setLengthUnit}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Radio
                                label='feet'
                                name='radioGroupLength'
                                value={1}
                                checked={profile.units_length === 1}
                                onChange={setLengthUnit}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group inline>
                        <Form.Field>
                            <Radio
                                label='dBm'
                                name='radioGroupPower'
                                value={0}
                                checked={profile.units_power === 0}
                                onChange={setPowerUnit}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Radio
                                label='watt'
                                name='radioGroupPower'
                                value={1}
                                checked={profile.units_power === 1}
                                onChange={setPowerUnit}
                            />
                        </Form.Field>
                    </Form.Group>
                </div>
            </Form>
        </div>
    )

}

export default Settings;